import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@mui/material";
import { submitAssignmentAction } from "../../actions/submitAssignment";
import { useUser, useSetUser } from "../../globals/UserContext";
import { useAssignment } from "../../globals/AssignmentContext";
import { useSetAssignmentReview } from "../../globals/AssignmentReviewContext";

export default function SubmitButton(props) {
  const user = useUser();
  const setUser = useSetUser();
  const assignment = useAssignment();
  const setAssignmentReview = useSetAssignmentReview();

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleYes = () => {
    setOpen(false);
    handleSubmit();
  }

  const handleSubmit = () => {
    setAssignmentReview(() => ({
      user: user,
      assignmentID: assignment._id,
    }));
    props.setPage("assignmentReview");
    submitAssignmentAction(user._id, assignment._id, setUser);
  };

  return (
    <>
      <Button color="secondary" variant="contained" onClick={handleOpen}>
        Submit
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Slide}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          Are you sure you want to submit?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            This cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={handleYes}>Yes</Button>
          <Button color="primary" onClick={handleClose}>No</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
